import { Box, Button, Grid, Icon, IconButton, Tooltip, Typography } from '@mui/material'
import { useCallback, useContext, useEffect, useLayoutEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BaseMenu, BreadCrumb, CustomTable, SnackSimple } from '../../../../components'
import { DinamicForm } from '../../../../components/dinamicForm'
import { FiltersDrawer } from '../../../../components/filtersDrawer'
import Loader from '../../../../components/loader'
import { useContextState } from '../../../../hooks/theme'
import { icons } from '../../../../utils/icons'
import { Item, onChange } from '../../../../utils/types/generals'
import { ItemsInput, useColumn, useInput } from './intialStates'
import { getAll, itemTypeActionPlan } from './methods'
import { useStyles } from './styles'
import { actionPlansServices } from '../../../../service/actionPlans'
import { httpFetch } from '../../../../utils/crud'
import { FilterProps } from '../../../../hooks/filter/typing'
import { getDivisions, getQuestionnaires, getStore, getUserTypes, getUsers, getZones } from '../../../../utils/methods/geServiceWithItemsFormat'
import { RequestErrors, Roles, Types } from '../../../../utils/enums'
import { getStatus } from '../../../../hooks/status'
import { returnQuery, returnQueryWithPagination } from '../../../../utils/methods/returnQuery'
import { ModelDownloadButtons } from '../../../../components/donwloadFiles/model'
import { useDownload } from '../../../../hooks/download/useDownload'
import { ActionPlanContext } from '../../context'
import { formData, formatFilter, statusList } from './contants'
import SelectActionPlan from './components/selectActionPlan'
import { useTimeOut } from '../../../../hooks/timeOut'
import SimpleModal from '../../../../components/modal/simpleModal'
import { handleAllErrors } from '../../../../utils/methods/handleErrors'
import { useLocation, useNavigate } from "react-router-dom"

const ActionPlans = () => {
  const { executeFunction } = useTimeOut()
  const { t } = useTranslation()
  const { colors } = useContextState()
  const navigate = useNavigate()
  const location = useLocation()
  const [itemsSearch, setItemsSearch] = useState<ItemsInput>({})
  const inputs = useInput(itemsSearch)
  const [rows, setRows] = useState<any[]>([])
  const { filterData, actionPlanOfStores, doNotHaveAcces, setActionPlanOfStores, setFilterPayload, isChecked, notSelected, selectedIds, setIsChecked, setNotSelected, setSelectedIds } = useContext(ActionPlanContext)
  const styles = useStyles()
  const [classList, setClassList] = useState<Item[]>([])
  const [loadingTable, setLoadingTable] = useState(false)
  const typeActionPlan = useMemo(() => itemTypeActionPlan({ t }), [])
  const externalValidation: FilterProps['externalValidation'] = ({ name, value, body, setFilterData }) => {
    if (name === 'zone') {
      const { zonesClass } = body
      const newZonezClass = zonesClass?.filter((itemClass: Item) => value?.some((itemZone: any) => itemZone?.value == itemClass?.father))

      setItemsSearch((prev) => ({
        ...prev,
        zonesClass: value?.length <= 0 ? [] : classList?.filter((itemClass) => value?.some((itemZone: any) => itemZone?.value == itemClass?.father)),
      }))

      setFilterData((prev) => ({
        ...prev,
        zonesClass: newZonezClass,
      }))

      body = {
        ...body,
        zonesClass: newZonezClass,
      }
    }

    return body
  }
  const queryWithPagination = returnQueryWithPagination({ filter: filterData.filterString, sort: filterData.query.sort })
  const [tableDate, setTableDate] = useState({
    totalPages: 1,
    totalItems: 0,
    currentPages: 1,
  })

  const onChange: onChange = (e, blur) => {
    filterData.onChange(e, blur)
  }

  const cleanFilter = () => {
    filterData.cleanFilter()
  }

  const [isLoadingDelete, setIsLoadingDelete] = useState(false)

  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    message: '',
    type: Types.SUCCESS,
  })

  const [modal, setModal] = useState<{
    open: boolean
    title: string
    description?: string
    children?: JSX.Element
    removeCancel?: boolean
    confirm: () => void
  }>({
    open: false,
    title: t('general.confirmation'),
    description: '',
    confirm: () => { },
  })

  const getData = useCallback(async (data?: { queries?: string; reloadData?: boolean }) => {
    setLoadingTable(true)
    getAll(t, colors, { ...data, queries: `by_store=${actionPlanOfStores}${!!data?.queries ? `&${data.queries}` : ''}` })
      .then((response) => {
        const { row, currentPage, totalItems, totalPages } = response
        setTableDate({
          currentPages: currentPage,
          totalItems,
          totalPages,
        })
        setRows(row)
      })
      .finally(() => {
        setLoadingTable(false)
      })
    // eslint-disable-next-line
  }, [actionPlanOfStores])

  const getTypeCreationItems = () => {
    setItemsSearch((prev) => ({
      ...prev,
      typeCreation: [
        { label: t('actionPlan.creationType.manualByExecution'), value: 'manual' },
        { label: t('actionPlan.creationType.manualLabel'), value: 'manual_module' },
        { label: t('actionPlan.typeCreationAutomatic'), value: 'automatic' },
      ],
    }))
  }

  const getStatusByService = () => {
    setItemsSearch((prev) => ({
      ...prev,
      status: statusList.map((item) => {
        const newStatus = getStatus(item, colors, t)
        return {
          label: newStatus.text,
          value: item,
        }
      }),
    }))
  }

  const getDivision = async () => {
    const divisions = await getDivisions()
    setItemsSearch((prev) => ({
      ...prev,
      divisions: divisions.items,
    }))
  }

  const getStoreService = async () => {
    const { items } = await getStore()
    setItemsSearch((prev) => ({
      ...prev,
      stores: items,
    }))
  }

  const getUserService = async () => {
    // const role = getUserRole()
    // if (role === Roles.AGENT) return
    const { items } = await getUsers({
      skip: [Roles.ADMIN],
      addUserLogged: true,
    });
    setItemsSearch((prev) => ({
      ...prev,
      user: items,
    }))
  }

  const getUserTypeService = async () => {
    const { items } = await getUserTypes()
    setItemsSearch((prev) => ({
      ...prev,
      userType: items,
    }))
  }

  const getQuestionnaire = async () => {
    const questionnaire = await getQuestionnaires()
    setItemsSearch((prev) => ({
      ...prev,
      questionnaire: questionnaire.items,
    }))
  }

  const getZonesAndClass = async () => {
    const questionnaire = await getZones()
    setClassList(questionnaire.childZones)
    setItemsSearch((prev) => ({
      ...prev,
      zone: questionnaire.fatherZones,
    }))
    const newZonezClass = questionnaire.childZones?.filter((itemClass: Item) => filterData.filterData.zone?.some((itemZone: any) => itemZone?.value == itemClass?.father))
    setItemsSearch((prev) => ({
      ...prev,
      zonesClass: newZonezClass ?? [],
    }))
  }

  const handleOpenModalDelete = () => {
    if (selectedIds.length === 0 && !isChecked) {
      setSnackbarOpen(prev => ({
        ...prev,
        open: true,
        message: t('actionPlan.snackbar.selectAtLeastOnePlan'),
        type: Types.ERROR
      }))
    } else {
      setModal(prev => ({
        ...prev,
        open: true,
        title: t('actionPlan.areYouSureWantDeleteAllPlansSelected', { count: selectedIds.length }),
        description:t('actionPlan.toDeleteTheSelectedPlans'),
        confirm: () => { handleDeleteMasive() },
      }))
    }
  }
  const closeModalDelete = () => {
    setModal(prev => ({
      ...prev,
      open: false,
    }))
  }

  const closeSnackBarOpen = () => {
    setSnackbarOpen(prev => ({ ...prev, open: false }))
  }

  const handleDeleteUnique = async () => {
    setIsLoadingDelete(true)

    const response = await actionPlansServices(httpFetch).deleteUnique(Number(detail.id))

    if (response.code == '01') {
      setSnackbarOpen(prev => ({ ...prev, open: true, message: t('actionPlan.snackbar.delete.success.unique'), type: Types.SUCCESS }))
      setSelectedIds([]);
      setNotSelected([]);
      setIsChecked(false)
      getData({ queries: returnQuery(filterData.query, formData) })
    } else {
      setSnackbarOpen(prev => ({ ...prev, open: true, message: handleAllErrors(response?.code as RequestErrors, t), type: Types.ERROR }))
    }

    setIsLoadingDelete(false)
    closeModalDelete()
  }

  const handleDeleteMasive = async () => {
    setIsLoadingDelete(true)

    const payload = {
      all: isChecked,
      actionPlanIds: isChecked ? [] : selectedIds,
      notIds: isChecked ? notSelected : []
    };

    const response = await actionPlansServices(httpFetch).deleteMasive(payload, isChecked ? `by_store=${actionPlanOfStores}&${returnQuery({ ...filterData.query, filter: filterData.query.filter?.replaceAll('+', '%2B') }, formData)}` : undefined)

    if (response.code == '00') {
      setSnackbarOpen(prev => ({ ...prev, open: true, message: t('actionPlan.snackbar.delete.success.masive'), type: Types.SUCCESS }))
      setSelectedIds([]);
      setNotSelected([]);
      setIsChecked(false)
      getData({ queries: returnQuery(filterData.query, formData) })
    } else {
      setSnackbarOpen(prev => ({ ...prev, open: true, message: handleAllErrors(response?.code as RequestErrors, t), type: Types.ERROR }))
    }

    setIsLoadingDelete(false)
    closeModalDelete()
  }

  const handleDeleteUniqueOpen = () => {
    setModal(prev => ({
      ...prev,
      open: true,
      title: t('general.confirmation'),
      description: t('actionPlan.areYouSureWantDeleteThisPlanSelected'),
      confirm: () => { handleDeleteUnique() },
    }))
  }

  const { column, closeMenu, detail, optionMenu } = useColumn(t, rows?.length, setIsChecked, selectedIds, isChecked, setSelectedIds, notSelected, setNotSelected, handleDeleteUniqueOpen, actionPlanOfStores)

  const {
    download,
    openSnackbar: snackbarDownloadModal,
    downloadCSV,
    downloadPDF,
    downloadWORD,
    closeOpenSnakbar,
  } = useDownload({
    docName: t('general.tags.actionPlan'),
    query: `&by_store=${actionPlanOfStores}${queryWithPagination ?? ''}`,
    downloadFuntion: actionPlansServices(httpFetch).getRegister,
  })

  useLayoutEffect(() => {
    getDivision()
    getStatusByService()
    getTypeCreationItems()
    getStoreService()
    getUserService()
    getQuestionnaire()
    getZonesAndClass()
    getUserTypeService()
  }, [])

  useEffect(() => {
    executeFunction({
      execute: () => {
        getData({ queries: returnQuery(filterData.query, formData) })
        setSelectedIds([]);
        setNotSelected([]);
        setIsChecked(false)
      }
    })
    //eslint-disable-next-line
  }, [filterData.query.all, actionPlanOfStores])

  useEffect(() => {
    if (location.state?.actionPlanCreated) {
      if (typeof location.state?.actionPlanOfStores === 'boolean') {
        setActionPlanOfStores(location.state.actionPlanOfStores)
      }

      setSnackbarOpen(prev => ({
        ...prev,
        open: true,
        message: t('actionPlan.snackbar.create.success'),
        type: Types.SUCCESS,
      }))

      navigate(location.pathname, {
        replace: true,
        state: {},
      })
    }
    //eslint-disable-next-line
  }, [location.state])

  useLayoutEffect(() => {
    setFilterPayload({
      formatFilter,
      externalValidation
    })
  }, [classList])
  return (
    <Box sx={styles.container}>
      <SnackSimple close={closeOpenSnakbar} open={snackbarDownloadModal.open} type={snackbarDownloadModal.type} message={snackbarDownloadModal.message} />
      <BreadCrumb
        removeBreadcrumb={['created']}
        replacePath={{ 'action-plan': '/dashboard/action-plan/created' }}
      />
      {/* HEADER */}
      <Box sx={[styles.header]}>
        <Typography variant='title_grey_big'>{t('actionPlan.title')}</Typography>

        <Box sx={styles.flex}>
          {
            !!doNotHaveAcces && (
              <Box sx={styles.titleContainer}>
                <SelectActionPlan
                  value={!!actionPlanOfStores}
                  onChange={(_, value) => {
                    filterData.handlePagination({ page: 1, pageSize: filterData.paginationModel.pageSize })
                    setActionPlanOfStores(value)
                  }}
                  items={typeActionPlan}
                />
              </Box>
            )
          }

          <Button variant="outlined" color="primary" onClick={handleOpenModalDelete}>
            {t('general.delete')}
          </Button>

          <ModelDownloadButtons styleType csv={downloadCSV} pdf={downloadPDF} word={downloadWORD} disableCSV={download?.excel} disablePDF={download?.pdf} disableWORD={download?.word} />

          <Tooltip title={t('ToolTips.create')}>
            <IconButton
              sx={styles.addButton}
              onClick={() => {
                navigate(`/dashboard/action-plan/create`)
              }}
            >
              {icons('add')}
            </IconButton>
          </Tooltip>

          {!!filterData.counter &&
            <Tooltip title={t('ToolTips.clearFilters')}>
              <IconButton
                sx={(styles.clean, (filterData.counter || 0) > 0 ? null : styles.hide)}
                onClick={() => {
                  cleanFilter()
                }}
              >
                {icons('clean')}
              </IconButton>
            </Tooltip>
          }
        </Box>
      </Box>

      {/* FLOATS */}
      <FiltersDrawer cleanFilter={cleanFilter} count={filterData.counter} right={0} top={50}>
        <Box sx={styles.section}>
          <DinamicForm errors={filterData.errors} input={Object.values(inputs)} values={filterData.filterData} onChange={onChange} filter={true} />
        </Box>
      </FiltersDrawer>

      <BaseMenu
        sx={[styles.baseMenu, detail.positionMenu]}
        anchorEl={detail.anchor}
        setAnchorEl={closeMenu}
        menuItems={detail.menu}
        click={(item) => {
          optionMenu({ item: item as Item })
        }}
      />

      {!loadingTable ? (
        <CustomTable
          order={
            filterData.query?.sort && {
              count: filterData.query?.sort?.count,
              key: filterData.query?.sort?.field,
              order: filterData.query?.sort?.sort,
            }
          }
          sortable={(field, sort, count) => {
            filterData.sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
          }}
          serverSidePagination={{
            page: (filterData.paginationModel.page ?? 0) + 1,
            size: filterData.paginationModel?.pageSize ?? 20,
            totalPages: tableDate.totalPages,
          }}
          handleChange={(page: number, pageSize: number) => {
            filterData.handlePagination({ page, pageSize })
          }}
          alignStatus="start"
          column={column}
          row={rows}
          color={colors}
          selected={-1}
        />
      ) : (
        <Loader sx={{ height: 'calc(100% - 200px)' }} />
      )}

      <SnackSimple open={snackbarOpen.open} close={closeSnackBarOpen} message={snackbarOpen.message} type={snackbarOpen.type} />

      <SimpleModal
        open={!!modal.open}
        next={modal.confirm}
        back={closeModalDelete}
        close={closeModalDelete}
        description={modal.description}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        title={modal.title}
        loadingButton
        isLoading={isLoadingDelete}
      />
    </Box>
  )
}

export default ActionPlans
